import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import 'element-plus/theme-chalk/index.css';
import ElementPlus from 'element-plus';

createApp(App)
    .use(store)
    .use(router)
    .use(i18n)
    .use(ElementPlus)
    .mount('#app')
